import React, { useContext } from "react";
import { ListGroup } from "react-bootstrap";

// Components
import Spinner from "../../Spinners/Spinner";

// Utils
import { ChatContext } from "../../../context/chat/ChatContext";
import { useGetDta } from "../../../hooks/useGetDta";

/**
 * Pestaña de enlaces de chat
 *
 * @returns {JSX.Element} Componente de react
 */
const LinksTab = () => {
  // Contexto del chat
  const { chatState } = useContext(ChatContext);
  const { activeChat } = chatState;

  // Obtener enlaces del chat
  const { loading, data } = useGetDta(
    `sms/links`,
    {
      id: activeChat.id_user || activeChat.id,
    },
    "POST"
  );

  if (loading) return <Spinner />;

  return (
    <div>
      <ListGroup>
        {!data.length && (
          <div className="text-center">
            <p className="text-secondary">No hay enlaces</p>
          </div>
        )}
        {data.map((link, index) => (
          <ListGroup.Item
            key={index}
            className="d-flex align-items-center rounded"
          >
            <a
              href={link}
              className="text-decoration-none font-14 flex-grow-1"
              target="_blank"
              rel="noreferrer"
              title={link}
              style={{
                maxWidth: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              <i className="mdi mdi-link-variant font-18 me-2" />
              {link}
            </a>
          </ListGroup.Item>
        ))}
      </ListGroup>
    </div>
  );
};

export default LinksTab;
